module.exports = __webpack_public_path__ + "static/img/gov-icon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gov-icon.png
// module id = L8qM
// module chunks = 1